// SAD-431 — TanStack Query bindings for the viewer's actionable attention.
// The server filters per viewer on every read; nothing here caches an item
// beyond the query key.
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { attentionClient } from '../../lib/connect/clients';
export const ATTENTION_KEY = 'library-attention';
export function useAttention() {
    return useQuery({
        queryKey: [
            ATTENTION_KEY
        ],
        queryFn: ()=>attentionClient.listAttention({})
    });
}
export function useResolveAttention() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id)=>attentionClient.resolveAttention({
                id
            }),
        onSuccess: ()=>qc.invalidateQueries({
                queryKey: [
                    ATTENTION_KEY
                ]
            })
    });
}
